import { ENextModule } from 'store/reducers/otherModuleAction.reducer'
import { AppThunk } from './base.action'

export const REQUEST_OTHER_USER_PERMISSION_START =
    'REQUEST_OTHER_USER_PERMISSION_START'
export const REQUEST_OTHER_USER_PERMISSION_FAILED =
    'REQUEST_OTHER_USER_PERMISSION_FAILED'
export const REQUEST_OTHER_USER_PERMISSION_SUCCESS =
    'REQUEST_OTHER_USER_PERMISSION_SUCCESS'

export const CLEAR_SHORT_LIFE_PERMISSIONS = 'CLEAR_SHORT_LIFE_PERMISSIONS'
export const CLEAR_PERMISSION_TOKEN = 'CLEAR_PERMISSION_TOKEN'

export const TOGGLE_PIN_DIALOG = 'TOGGLE_PIN_DIALOG'

export const SET_NEXT_MODULE = 'SET_NEXT_MODULE'

export const requestOtherUserPermissionStart = () => ({
    type: REQUEST_OTHER_USER_PERMISSION_START,
})

export const requestOtherUserPermissionFailed = (err: any) => ({
    type: REQUEST_OTHER_USER_PERMISSION_FAILED,
    payload: err,
})

export const requestOtherUserPermissionSuccess = (
    permissionToken: string,
    aqquiredModuleActionIds: number[],
) => ({
    type: REQUEST_OTHER_USER_PERMISSION_SUCCESS,
    payload: {
        permissionToken,
        aqquiredModuleActionIds,
    },
})

export function togglePinDialog(open: boolean): AppThunk {
    return (dispatch) => {
        dispatch({ type: TOGGLE_PIN_DIALOG, payload: open })
    }
}
export function clearShortLifePermission(): AppThunk {
    return (dispatch) => {
        dispatch({ type: CLEAR_SHORT_LIFE_PERMISSIONS })
    }
}
export function clearPermissionToken(): AppThunk {
    return (dispatch) => dispatch({ type: CLEAR_PERMISSION_TOKEN })
}
export function setNextModule(payload: { module?: ENextModule }): AppThunk {
    return (dispatch) => {
        dispatch({ type: SET_NEXT_MODULE, payload: payload })
    }
}
